export const franceIsoCode = 'FR';

export const unitedStatesIsoCode = 'US';

export const frenchTerritoryIsoCodes = [
  'GP',
  'MQ',
  'GF',
  'RE',
  'PM',
  'YT',
  'BL',
  'MF',
  'WF',
  'PF',
  'NC',
  'TF',
] as const;

export const americanTerritoryIsoCodes = ['AS', 'GU', 'MP', 'PR', 'UM', 'VI'] as const;

export const allFranceIsoCodes = [franceIsoCode, ...frenchTerritoryIsoCodes] as const;

export const allUnitedStatesIsoCode = [unitedStatesIsoCode, ...americanTerritoryIsoCodes] as const;

export type FrIsoCodes = typeof allFranceIsoCodes;
export type UsIsoCodes = typeof allUnitedStatesIsoCode;

export type FrIsoCode = FrIsoCodes[number];
export type UsIsoCode = UsIsoCodes[number];

export type IsoCodes = FrIsoCode[] | UsIsoCode[];
export type IsoCode = IsoCodes[number];

export const usStates = [
  { code: 'AL', en: 'Alabama', fr: 'Alabama' },
  { code: 'AK', en: 'Alaska', fr: 'Alaska' },
  { code: 'AZ', en: 'Arizona', fr: 'Arizona' },
  { code: 'AR', en: 'Arkansas', fr: 'Arkansas' },
  { code: 'CA', en: 'California', fr: 'Californie' },
  { code: 'CO', en: 'Colorado', fr: 'Colorado' },
  { code: 'CT', en: 'Connecticut', fr: 'Connecticut' },
  { code: 'DE', en: 'Delaware', fr: 'Delaware' },
  { code: 'DC', en: 'District Of Columbia', fr: 'District de Columbia' },
  { code: 'FL', en: 'Florida', fr: 'Floride' },
  { code: 'GA', en: 'Georgia', fr: 'Géorgie' },
  { code: 'HI', en: 'Hawaii', fr: 'Hawaï' },
  { code: 'ID', en: 'Idaho', fr: 'Idaho' },
  { code: 'IL', en: 'Illinois', fr: 'Illinois' },
  { code: 'IN', en: 'Indiana', fr: 'Indiana' },
  { code: 'IA', en: 'Iowa', fr: 'Iowa' },
  { code: 'KS', en: 'Kansas', fr: 'Kansas' },
  { code: 'KY', en: 'Kentucky', fr: 'Kentucky' },
  { code: 'LA', en: 'Louisiana', fr: 'Louisiane' },
  { code: 'ME', en: 'Maine', fr: 'Maine' },
  { code: 'MD', en: 'Maryland', fr: 'Maryland' },
  { code: 'MA', en: 'Massachusetts', fr: 'Massachusetts' },
  { code: 'MI', en: 'Michigan', fr: 'Michigan' },
  { code: 'MN', en: 'Minnesota', fr: 'Minnesota' },
  { code: 'MS', en: 'Mississippi', fr: 'Mississippi' },
  { code: 'MO', en: 'Missouri', fr: 'Missouri' },
  { code: 'MT', en: 'Montana', fr: 'Montana' },
  { code: 'NE', en: 'Nebraska', fr: 'Nebraska' },
  { code: 'NV', en: 'Nevada', fr: 'Nevada' },
  { code: 'NH', en: 'New Hampshire', fr: 'Nouveau-Hampshire' },
  { code: 'NJ', en: 'New Jersey', fr: 'New Jersey' },
  { code: 'NM', en: 'New Mexico', fr: 'Nouveau-Mexique' },
  { code: 'NY', en: 'New York', fr: 'New York' },
  { code: 'NC', en: 'North Carolina', fr: 'Caroline du Nord' },
  { code: 'ND', en: 'North Dakota', fr: 'Dakota du Nord' },
  { code: 'OH', en: 'Ohio', fr: 'Ohio' },
  { code: 'OK', en: 'Oklahoma', fr: 'Oklahoma' },
  { code: 'OR', en: 'Oregon', fr: 'Oregon' },
  { code: 'PA', en: 'Pennsylvania', fr: 'Pennsylvanie' },
  { code: 'RI', en: 'Rhode Island', fr: 'Rhode Island' },
  { code: 'SC', en: 'South Carolina', fr: 'Caroline du Sud' },
  { code: 'SD', en: 'South Dakota', fr: 'Dakota du Sud' },
  { code: 'TN', en: 'Tennessee', fr: 'Tennessee' },
  { code: 'TX', en: 'Texas', fr: 'Texas' },
  { code: 'UT', en: 'Utah', fr: 'Utah' },
  { code: 'VT', en: 'Vermont', fr: 'Vermont' },
  { code: 'VA', en: 'Virginia', fr: 'Virginie' },
  { code: 'WA', en: 'Washington', fr: 'Washington' },
  { code: 'WV', en: 'West Virginia', fr: 'Virginie-Occidentale' },
  { code: 'WI', en: 'Wisconsin', fr: 'Wisconsin' },
  { code: 'WY', en: 'Wyoming', fr: 'Wyoming' },
];
